"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[182],{

/***/ 30996:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  c: () => (/* binding */ useResubscribe)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useApolloClients.tsx
var useApolloClients = __webpack_require__(60440);
// EXTERNAL MODULE: ./local_modules/analytics/dataLayer/index.ts
var dataLayer = __webpack_require__(94148);
// EXTERNAL MODULE: ./src/helpers/errors/index.ts
var errors = __webpack_require__(83305);
// EXTERNAL MODULE: ./src/modules/coupon/useCouponData.ts
var useCouponData = __webpack_require__(42191);
// EXTERNAL MODULE: ./src/modules/subscription/resubscribe/useResubscribeOrigin.ts
var useResubscribeOrigin = __webpack_require__(11271);
;// CONCATENATED MODULE: ./src/modules/subscription/resubscribe/graph/resubscribe.graphql.ts
const ResubscribeDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "Resubscribe"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "input"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "SubscriptionResubscribeInput"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "subscriptionResubscribe"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "input"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "ResubscribePayload"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "ResubscribeError"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "SubscriptionResubscribeError"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ResubscribeError"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "alias": {
                                        "kind": "Name",
                                        "value": "resubscribeErrorCode"
                                    },
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorCode"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "message"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "CouponError"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "alias": {
                                        "kind": "Name",
                                        "value": "couponErrorCode"
                                    },
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorCode"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "message"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "PurchaseError"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "alias": {
                                        "kind": "Name",
                                        "value": "purchaseErrorCode"
                                    },
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorCode"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "message"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ChangePlanError"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "alias": {
                                        "kind": "Name",
                                        "value": "changePlanErrorCode"
                                    },
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorCode"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "message"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "SecurityError"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "alias": {
                                        "kind": "Name",
                                        "value": "securityErrorCode"
                                    },
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorCode"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "message"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "BusinessError"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "alias": {
                                        "kind": "Name",
                                        "value": "businessErrorCode"
                                    },
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorCode"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "message"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "PaymentMethodError"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "alias": {
                                        "kind": "Name",
                                        "value": "paymentMethodErrorCode"
                                    },
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorCode"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "message"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "PaymentGatewayError"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "alias": {
                                        "kind": "Name",
                                        "value": "paymentGatewayErrorCode"
                                    },
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorCode"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "message"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "gatewayErrorCode"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "gatewayErrorMessage"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "ResubscribePayload"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "SubscriptionResubscribePayload"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "data"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reactivated"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "redirectUrl"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "error"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "ResubscribeError"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
ResubscribeDocument["definitions"] = [
    ...new Set(ResubscribeDocument.definitions)
];
/* harmony default export */ const resubscribe_graphql = (ResubscribeDocument);

;// CONCATENATED MODULE: ./src/modules/subscription/resubscribe/graph/resubscribeSessionInfo.graphql.ts
const ResubscribeSessionInfoDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "ResubscribeSessionInfo"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currentUser"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "purchaseSessionInfo"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "lastResubscribeSessionIdInProgress"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
ResubscribeSessionInfoDocument["definitions"] = [
    ...new Set(ResubscribeSessionInfoDocument.definitions)
];
/* harmony default export */ const resubscribeSessionInfo_graphql = (ResubscribeSessionInfoDocument);

;// CONCATENATED MODULE: ./src/modules/subscription/resubscribe/graph/waitForResubscribe.graphql.ts
const WaitForResubscribeDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "subscription",
            "name": {
                "kind": "Name",
                "value": "WaitForResubscribe"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "input"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "SubscriptionResubscribeSessionInput"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "subscriptionResubscribeSession"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "input"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "session"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "status"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "ResubscribePayload"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "ResubscribeError"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "SubscriptionResubscribeError"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ResubscribeError"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "alias": {
                                        "kind": "Name",
                                        "value": "resubscribeErrorCode"
                                    },
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorCode"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "message"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "CouponError"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "alias": {
                                        "kind": "Name",
                                        "value": "couponErrorCode"
                                    },
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorCode"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "message"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "PurchaseError"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "alias": {
                                        "kind": "Name",
                                        "value": "purchaseErrorCode"
                                    },
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorCode"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "message"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ChangePlanError"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "alias": {
                                        "kind": "Name",
                                        "value": "changePlanErrorCode"
                                    },
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorCode"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "message"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "SecurityError"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "alias": {
                                        "kind": "Name",
                                        "value": "securityErrorCode"
                                    },
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorCode"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "message"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "BusinessError"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "alias": {
                                        "kind": "Name",
                                        "value": "businessErrorCode"
                                    },
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorCode"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "message"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "PaymentMethodError"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "alias": {
                                        "kind": "Name",
                                        "value": "paymentMethodErrorCode"
                                    },
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorCode"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "message"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "InlineFragment",
                        "typeCondition": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "PaymentGatewayError"
                            }
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "alias": {
                                        "kind": "Name",
                                        "value": "paymentGatewayErrorCode"
                                    },
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorCode"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "message"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "gatewayErrorCode"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "gatewayErrorMessage"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "ResubscribePayload"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "SubscriptionResubscribePayload"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "data"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reactivated"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "redirectUrl"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "error"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "ResubscribeError"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
WaitForResubscribeDocument["definitions"] = [
    ...new Set(WaitForResubscribeDocument.definitions)
];
/* harmony default export */ const waitForResubscribe_graphql = (WaitForResubscribeDocument);

;// CONCATENATED MODULE: ./src/modules/subscription/resubscribe/useResubscribe.ts









const useResubscribeMutation = ()=>{
    const apolloClient = (0,useApolloClients/* useApolloClient */.x)();
    const resubscribeMutation = (0,react.useCallback)(async (input)=>{
        const result = await apolloClient.mutate({
            mutation: resubscribe_graphql,
            variables: {
                input
            },
            fetchPolicy: "network-only"
        });
        if (result.errors) {
            throw new errors/* GraphQLError */.__(result.errors);
        }
        const { data, error } = result.data.subscriptionResubscribe;
        if (error) {
            throw new errors/* UserError */.gK(error);
        }
        return data;
    }, [
        apolloClient
    ]);
    const getResubscribeSessionId = (0,react.useCallback)(async ()=>{
        var _result_data_currentUser_data_purchaseSessionInfo, _result_data_currentUser_data, _result_data_currentUser;
        const result = await apolloClient.query({
            query: resubscribeSessionInfo_graphql,
            fetchPolicy: "network-only"
        });
        if (result.errors) {
            throw new errors/* GraphQLError */.__(result.errors);
        }
        const sessionId = (_result_data_currentUser = result.data.currentUser) === null || _result_data_currentUser === void 0 ? void 0 : (_result_data_currentUser_data = _result_data_currentUser.data) === null || _result_data_currentUser_data === void 0 ? void 0 : (_result_data_currentUser_data_purchaseSessionInfo = _result_data_currentUser_data.purchaseSessionInfo) === null || _result_data_currentUser_data_purchaseSessionInfo === void 0 ? void 0 : _result_data_currentUser_data_purchaseSessionInfo.lastResubscribeSessionIdInProgress;
        if (!sessionId) {
            throw new errors/* ServerError */.nl(null, "Resubscribe session not found");
        }
        return sessionId;
    }, [
        apolloClient
    ]);
    const waitForResubscribe = (0,react.useCallback)((input)=>{
        return new Promise((resolve, reject)=>{
            const observableQuery = apolloClient.subscribe({
                query: waitForResubscribe_graphql,
                fetchPolicy: "network-only",
                variables: {
                    input
                },
                context: {
                    webSocket: true
                }
            });
            let subscription = observableQuery.subscribe({
                next: (param)=>{
                    let { data } = param;
                    const { session, error } = data.subscriptionResubscribeSession || {};
                    if ((session === null || session === void 0 ? void 0 : session.status) === "SUCCESS") {
                        endSubscription();
                        resolve(data.subscriptionResubscribeSession);
                    } else if ((session === null || session === void 0 ? void 0 : session.status) === "FAILED" || !session && error) {
                        endSubscription();
                        reject(new errors/* UserError */.gK(error, (error === null || error === void 0 ? void 0 : error.message) || "Wait for resubscribe error"));
                    }
                },
                error: (error)=>{
                    endSubscription();
                    reject(new errors/* ServerError */.nl(error));
                },
                complete: ()=>{
                    endSubscription();
                }
            });
            const endSubscription = ()=>{
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = null;
                }
            };
        });
    }, [
        apolloClient
    ]);
    return (0,react.useCallback)(async (input)=>{
        try {
            return await resubscribeMutation(input);
        } catch (error) {
            var // if it's a gateway timeout error, then we start waiting for the commit
            _error_networkError, _error_cause, _error_cause1;
            const isPostponedPurchase = (error === null || error === void 0 ? void 0 : (_error_networkError = error.networkError) === null || _error_networkError === void 0 ? void 0 : _error_networkError.statusCode) === 504 || (error === null || error === void 0 ? void 0 : (_error_cause = error.cause) === null || _error_cause === void 0 ? void 0 : _error_cause.purchaseErrorCode) === "EXTERNAL_NETWORK_ISSUE" || (error === null || error === void 0 ? void 0 : (_error_cause1 = error.cause) === null || _error_cause1 === void 0 ? void 0 : _error_cause1.purchaseErrorCode) === "PURCHASE_IN_PROGRESS";
            if (isPostponedPurchase) {
                const sessionId = await getResubscribeSessionId();
                return await waitForResubscribe({
                    sessionId
                });
            }
            throw error;
        }
    }, [
        resubscribeMutation,
        getResubscribeSessionId,
        waitForResubscribe
    ]);
};
const useResubscribe = ()=>{
    const origin = (0,useResubscribeOrigin/* useResubscribeOrigin */.z)();
    const apolloClient = (0,useApolloClients/* useApolloClient */.x)();
    const resubscribeMutation = useResubscribeMutation();
    const resetCouponsCache = (0,useCouponData/* useResetCouponsCache */.P)();
    return (0,react.useCallback)(async (input)=>{
        try {
            const data = await resubscribeMutation({
                ...input,
                origin
            });
            dataLayer/* default */.Z.track("resubscribe", {
                resubscribePath: "from one click"
            });
            return data;
        } finally{
            // reset queue cache, because plan can change
            apolloClient.cache.evict({
                id: "UserData:{}",
                fieldName: "queue"
            });
            await apolloClient.refetchQueries({
                include: [
                    "Subscription"
                ]
            });
            // ATTN we should reset coupons cache to refetch all coupons info
            resetCouponsCache();
        }
    }, [
        apolloClient,
        origin,
        resubscribeMutation,
        resetCouponsCache
    ]);
};


/***/ }),

/***/ 64881:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   W: () => (/* binding */ useResubscribeOffer)
/* harmony export */ });
/* unused harmony export useResubscribeOfferData */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var cookie_storage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9424);
/* harmony import */ var router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(91746);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64667);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23450);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63687);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94957);
/* harmony import */ var modules_coupon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42191);
/* harmony import */ var _useResubscribeOrigin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11271);








// all available offers
const offers = [
    "discount",
    "off50",
    "off60",
    "freeProduct",
    "freeCase",
    "freeMonth",
    "noDiscount"
];
// rotation of offers in regular resubscribe flow
const offersRotation = [
    "discount",
    "off50",
    "freeProduct",
    "freeCase",
    "freeMonth",
    "noDiscount"
];
const eventOffers = {
    "discount": "$6.95 off",
    "off50": "50% off",
    "off60": "60% off",
    "freeProduct": "Free product",
    "freeCase": "Free case",
    "freeMonth": "Free month",
    "noDiscount": "No offer"
};
const coupons = {
    discount: "RESUBNEW",
    off50: "RESUB50",
    off60: "RESUB60",
    freeProduct: "RESUBFREEPRODUCT",
    freeCase: "RESUBFREECASE",
    freeMonth: "RESUBFREE"
};
const pathToOffer = {
    [links__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP.resubscribeNoOffer]: "noDiscount",
    [links__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP.resubscribe50]: "off50",
    [links__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP.resubscribe60]: "off60",
    [links__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP.resubscribeFree]: "freeMonth",
    [links__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP.resubscribeFreeProduct]: "freeProduct",
    [links__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP.resubscribeFreeCase]: "freeCase"
};
// returns info about an offer
const useResubscribeOfferData = (offer)=>{
    const couponCode = coupons[offer];
    const origin = (0,_useResubscribeOrigin__WEBPACK_IMPORTED_MODULE_2__/* .useResubscribeOrigin */ .z)();
    const { couponData, isCouponDataFetching, isCouponUnavailable } = (0,modules_coupon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        couponCode,
        origin
    });
    const freeProduct = couponData === null || couponData === void 0 ? void 0 : couponData.freeProduct;
    const discountAmount = couponData === null || couponData === void 0 ? void 0 : couponData.discountAmount;
    const formattedDiscountAmount = discountAmount ? (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(discountAmount) : null;
    const discountPercentage = couponData === null || couponData === void 0 ? void 0 : couponData.discountPercentage;
    const eventOffer = offer === "discount" ? `${formattedDiscountAmount} off` : eventOffers[offer];
    const giftSubscriptionOfferCookie = cookie_storage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP.getItem(helpers__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.cookieNames.giftSubscriptionOffer);
    const giftSubscriptionOffer = giftSubscriptionOfferCookie && parseInt(giftSubscriptionOfferCookie, 10);
    const isHoliday22Resubscribe60 = (0,hooks__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.features.holiday22Resubscribe60);
    const isRestrictedCoupon = offer === "off60" && !isHoliday22Resubscribe60;
    const isAvailable = !isRestrictedCoupon && (!couponCode || Boolean(couponData));
    const isUnavailable = isRestrictedCoupon || (couponCode ? isCouponUnavailable : false);
    return {
        offer,
        giftSubscriptionOffer,
        eventOffer,
        couponCode,
        freeProduct,
        discountAmount,
        formattedDiscountAmount,
        discountPercentage,
        isFetching: isCouponDataFetching,
        isAvailable,
        isUnavailable
    };
};
const useResubscribeOffer = (params)=>{
    // offer will be the first offer to check, if withRotation is true, force offer will be replaced when unavailable
    const { forceOffer, withRotation = true } = params || {};
    // we can redefine default value by search param
    const [{ forceOffer: queryOffer }] = (0,router__WEBPACK_IMPORTED_MODULE_8__/* .useSearchParams */ .lr)();
    const pathname = (0,router__WEBPACK_IMPORTED_MODULE_8__/* .usePathname */ .jD)();
    const pathOffer = pathToOffer[pathname];
    const [offer, setOffer] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>{
        if (forceOffer && offers.includes(forceOffer)) {
            cookie_storage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP.setItem(helpers__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.cookieNames.resubscribeOffer, forceOffer);
            return forceOffer;
        }
        // offer search param has the highest priority, but it should be one of the predefined offers
        if (queryOffer && offers.includes(queryOffer)) {
            return queryOffer;
        }
        // offers from landing pages
        if (pathOffer && offers.includes(pathOffer)) {
            return pathOffer;
        }
        // then check previously saved offer
        const cookieOffer = cookie_storage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP.getItem(helpers__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.cookieNames.resubscribeOffer);
        if (cookieOffer && offers.includes(cookieOffer)) {
            return cookieOffer;
        }
        // otherwise, first offer from the list
        return offersRotation[0];
    });
    const offerData = useResubscribeOfferData(offer);
    const { isUnavailable, isAvailable } = offerData;
    const offerIndex = offersRotation.indexOf(offer);
    const needNextOffer = withRotation && isUnavailable && offerIndex < offersRotation.length - 1;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (needNextOffer) {
            const nextOffer = offersRotation[offerIndex + 1] || "noDiscount";
            setOffer(nextOffer);
        }
    }, [
        offerIndex,
        needNextOffer
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        // save offer to a cookie to keep the same offer across the website
        if (offer && isAvailable) {
            cookie_storage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP.setSessionItem(helpers__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.cookieNames.resubscribeOffer, offer);
        }
    }, [
        offer,
        isAvailable
    ]);
    return {
        ...offerData,
        isFetching: offerData.isFetching || needNextOffer
    };
};


/***/ }),

/***/ 11271:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   z: () => (/* binding */ useResubscribeOrigin)
/* harmony export */ });
/* harmony import */ var cookie_storage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9424);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63687);


const useResubscribeOrigin = ()=>{
    const isFromEmail = cookie_storage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP.getItem(helpers__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.cookieNames.fromEmail);
    return isFromEmail ? "EMAIL" : "SITE";
};


/***/ })

}]);